import { KentFeatureTypeEnum } from '@cast/types-kent';

/*
 * Derives the feature ID from the feature type enum
 * using the backend convention (lowercase + replace underscores with hyphens).
 * Eliminates the need to fetch all features just to resolve a feature ID
 * when the feature type is already known.
 * More info: https://castai.atlassian.net/browse/KENT-387?focusedCommentId=122232
 */
export const featureTypeToId = (type: KentFeatureTypeEnum): string => {
  return type.toLowerCase().replace(/_/g, '-');
};
